import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { IAskAIAnswer } from '@ispm/dashboard/ask-ai/interfaces/ask-a-i-answer.interface';
import { IAskAIQuestion } from '@ispm/dashboard/ask-ai/interfaces/ask-a-i-question.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';

@Injectable({ providedIn: 'root' })
export class AskAIService {

  readonly ASK_AI_CHAT_HISTORY: string = 'ask-ai-chat-history';

  /**
   * Constructor
   *
   * @param {IspmHttpClient} ispmHttpClient
   */
  constructor(
    private ispmHttpClient: IspmHttpClient,
  ) {
  }

  /**
   * Checking functionality of AI
   *
   * @param {string} appId
   *
   * @return {Observable<boolean>}
   */
  appIsFunctionality(appId: string): Observable<boolean> {
    return this.ispmHttpClient.get(`ask-ai/check-functionality/${appId}`, { }, false);
  }

  /**
   * Get answer
   *
   * @param {IAskAIQuestion} questionObject
   *
   * @return {Observable<IAskAIAnswer>}
   */
  getAnswer(questionObject: IAskAIQuestion): Observable<IAskAIAnswer> {
    return this.ispmHttpClient.post(
      'ask-ai',
      {
        question: questionObject.question,
        appId: questionObject.appId,
      },
      false
    );
  }

  /**
   * Get chat history
   *
   * @param {string} appId
   *
   * @return {Array<IAskAIAnswer>}
   */
  getChatHistory(appId: string): Array<IAskAIAnswer> {
    const chatHistory = JSON.parse(localStorage.getItem(this.ASK_AI_CHAT_HISTORY)) || {}; // the object is important!

    return chatHistory[appId] || [];
  }

  /**
   * Save chat history
   *
   * @param {string} appId
   * @param {Array<IAskAIAnswer>} answers
   *
   * @return {any}
   */
  saveChatHistory(appId: string, answers: Array<IAskAIAnswer>): any {
    let chatHistory = JSON.parse(localStorage.getItem(this.ASK_AI_CHAT_HISTORY)) || {}; // the object is important!
    chatHistory[appId] = answers;

    localStorage.setItem(this.ASK_AI_CHAT_HISTORY, JSON.stringify(chatHistory));

    return chatHistory;
  }

  /**
   * Clear chat history
   *
   * @param {string} appId
   *
   * @return {any}
   */
  clearChatHistory(appId: string): any {
    let chatHistory = JSON.parse(localStorage.getItem(this.ASK_AI_CHAT_HISTORY)) || {}; // the object is important!
    chatHistory[appId] = [];

    localStorage.setItem(this.ASK_AI_CHAT_HISTORY, JSON.stringify(chatHistory));

    return chatHistory;
  }

  /**
   * Delete chat history
   *
   * @return void
   */
  deleteChatHistory(): void {
    localStorage.removeItem(this.ASK_AI_CHAT_HISTORY);
  }
}
